/**
 * sq-custom.js - Sparq Search Price Gate
 * Hides prices in the Sparq predictive search bar for products tagged
 * with 'hide_price' or 'login_price' when the customer is not authorized.
 *
 * Requires window.SQPriceGate to be set in theme.liquid:
 *   { authorized: true/false, loggedIn: true/false }
 */
(function () {
  'use strict';

  // If customer is fully authorized, do nothing
  if (window.SQPriceGate && window.SQPriceGate.authorized === true) {
    return;
  }

  /**
   * Hide the price in a search result item and show login message
   */
  function hidePrice(item) {
    var priceEl = item.querySelector('.price-outer, .sq-sy-price');
    if (!priceEl) return;
    if (priceEl.dataset.priceGated) return;

    priceEl.dataset.priceGated = '1';
    priceEl.style.display = 'none';

    if (!item.querySelector('.sq-price-gate-msg')) {
      var msg = document.createElement('p');
      msg.className = 'sq-price-gate-msg';
      msg.style.cssText = 'font-size: 0.85em; color: #555; margin: 4px 0 0; font-style: italic;';
      msg.textContent = 'Log in to view price';
      priceEl.parentNode.insertBefore(msg, priceEl.nextSibling);
    }
  }

  /**
   * Check a product item and hide price if tagged with hide_price or login_price
   */
  function processItem(item) {
    if (item.dataset.sqPriceGateChecked) return;
    item.dataset.sqPriceGateChecked = '1';

    // Try to get handle from item attributes
    var handle = item.dataset.handle;
    if (!handle) {
      var handleEl = item.querySelector('[data-handle]');
      if (handleEl) handle = handleEl.dataset.handle;
    }
    if (!handle) {
      var linkEl = item.querySelector('a[href*="/products/"]');
      if (linkEl) {
        var match = linkEl.href.match(/\/products\/([^?#\/]+)/);
        if (match) handle = match[1];
      }
    }

    // Check inline tag data
    var inlineTags = item.dataset.tags || item.getAttribute('data-tags') || '';
    if (inlineTags && (inlineTags.includes('hide_price') || inlineTags.includes('login_price'))) {
      hidePrice(item);
      return;
    }

    if (!handle) return;

    // Fetch product tags
    fetch('/products/' + handle + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function(r) { return r.json(); })
      .then(function(product) {
        var tags = (product.tags || []).join(',');
        if (tags.indexOf('hide_price') !== -1 || tags.indexOf('login_price') !== -1) {
          hidePrice(item);
        }
      })
      .catch(function() {});
  }

  function processAllItems() {
    var items = document.querySelectorAll('.sq-results-item, .sparq-result-item');
    for (var i = 0; i < items.length; i++) {
      processItem(items[i]);
    }
  }

  function initObserver() {
    processAllItems();

    var observer = new MutationObserver(function(mutations) {
      var needsScan = false;
      for (var m = 0; m < mutations.length; m++) {
        var nodes = mutations[m].addedNodes;
        for (var n = 0; n < nodes.length; n++) {
          if (nodes[n].nodeType === 1) { needsScan = true; break; }
        }
        if (needsScan) break;
      }
      if (needsScan) processAllItems();
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initObserver);
  } else {
    initObserver();
  }

  document.addEventListener('sparq:results', processAllItems);
  document.addEventListener('sparq:autocomplete', processAllItems);
  document.addEventListener('sparq:dropdown:open', processAllItems);

})();